<template>
  <div>
    <div class="divider-onboarding col-span-3"></div>
    <div
      v-if="showTravelSection"
      id="onboardingStep2-section2"
      class="flex flex-col md:grid grid-cols-3"
    >
      <div class="col-span-2 grid sm:grid-cols-2">
        <component
          :is="item.component"
          v-for="(item, index) in preDepartureForms"
          :key="index"
          class="flex flex-col justify-start items-start"
          :application-id="$route.params.applicationId"
          :program-details="programDetails"
        >
        </component>
      </div>
      <div>
        <div class="flex flex-row justify-start items-start px-4 mt-4 md:mt-0">
          <!-- countdown component -->

        </div>
      </div>
    </div>
    <p  v-if="showTravelSection" class="text-xs text-gray-500 italic">Once you are accepted into your program, immediately review the visa requirements and timelines!
       <a href="https://apiabroad.com/student-visas" target="_blank">Click here for helpful information on our website.</a>
    </p>
  </div>
</template>

<script>
import postFormRules from "../../mixins/postFormRules";
import GroupVisaCard from "../forms/GroupVisaInformation/GroupVisaCard.vue";
import VisaAppointmentCard from "../forms/VisaAppointment/VisaAppointmentCard.vue";
import VisaAndPermitCard from "../forms/VisaAndPermit/VisaAndPermitCard.vue";
import { mapState } from "vuex";
import subDays from "date-fns/subDays";
import format from "date-fns/format";
import getTime from "date-fns/getTime";
import { endOfDay } from "date-fns";

export default {
  name: "TravelArrangementsSection",
  mixins: [postFormRules],
  props: {
    programDetails: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  computed: {
    ...mapState(["program"]),
    formatDeadline() {
      //due date = start date - 30 days
      let date = getTime(
        subDays(endOfDay(new Date(this.program.start_date)), 30)
      );
      return format(date, "yyyy-MM-dd");
    },
    showTravelSection() {
      return (
        this.showGroupVisaTile ||
        this.showVisaAppointmentTile ||
        this.showVisaAndPermitTile
      );
    },
    preDepartureForms() {
      //add the component for the form link that should display in this section
      //make sure to run the logic to show or hide the component inside of its self
      return [
        {
          component: GroupVisaCard,
        },
        {
          component: VisaAppointmentCard,
        },
        {
          component: VisaAndPermitCard,
        },
      ];
    },
  },
};
</script>